import React from 'react'
import clone from 'lodash.clone'

/**
 * By default, axios will throw any result from the API into 'data' prop,
 * making it weird to use (e.g. 'data.data.name'). This function will remap the
 * incoming result to a more readable format.
 */
const remap = <Data, Filters, QueryResult>({
  response,
  filters,
  setFilters
}) => {
  const output = clone(response)
  const metadata = clone(output?.data)

  delete metadata?.data

  output['data'] = response?.data?.data || response?.data
  output['metadata'] = metadata
  output['filters'] = filters
  output['setFilters'] = setFilters

  return output as QueryResult & {
    data: Data
    metadata: Record<string, any>
    filters: Filters
    setFilters: React.Dispatch<React.SetStateAction<Filters>>
  }
}

export default remap
